import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { FINANCIAL_INFORMATION_API } from "../api";
import {
  setIsNewForFinancialInformation,
  setIsDataChangedForFinancial,
  addErrorMessage,
  addSuccessMessage,
  setFinancialInformationData,
  setIsLoading,
} from "../slice";

export const useFinancialInfo = ({ hasEditAccess }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, isNew, isDataChanged } = useSelector((state) => state.FinancialInformation);

  const { mutateAsync: addFinancialInformation } = useMutation((data) =>
    FINANCIAL_INFORMATION_API.AddFinancialInformation(data)
  );

  const { mutateAsync: editFinancialInformation } = useMutation((data) =>
    FINANCIAL_INFORMATION_API.EditFinancialInformation(data)
  );

  const { mutate: getFinancialInformation } = useMutation(
    () => FINANCIAL_INFORMATION_API.GetFinancialInformation(),
    {
      onSuccess: ({ data: FinancialInformation }) => {
        if (FinancialInformation.success && FinancialInformation.data) {
          dispatch(setFinancialInformationData(FinancialInformation.data));
          // setUnemployed(parseInt(FinancialInformation.data.employmentStatusCode) === 20002);
        }
        dispatch(setIsLoading(false));
      },
      onError: () => {
        dispatch(setIsLoading(false));
      },
      staleTime: Infinity,
    }
  );

  const handleSubmit = async (route) => {
    if (hasEditAccess && isDataChanged) {
      if (isNew) {
        await addFinancialInformation(data, {
          onSuccess: ({ data }) => {
            if (data.success) {
              dispatch(setIsNewForFinancialInformation(false));
              dispatch(addSuccessMessage(data?.message));
              navigate(route);
            }
          },
          onSettled: () => {
            dispatch(setIsDataChangedForFinancial(false));
          },
          onError: ({ response }) => {
            dispatch(addErrorMessage(response));
          },
        });
      } else {
        await editFinancialInformation(data, {
          onSuccess: ({ data }) => {
            if (data.success) {
              dispatch(addSuccessMessage(data?.message));
              navigate(route);
            }
          },
          onSettled: () => {
            dispatch(setIsDataChangedForFinancial(false));
          },
          onError: ({ response }) => {
            dispatch(addErrorMessage(response));
          },
        });
      }
    } else {
      navigate(route);
    }
  };
  return { handleSubmit, getFinancialInformation };
};
